import React from 'react';
import ReactDOM from 'react-dom/client';
import AppProvider from './contexts/AppContext';
import history from './history';
import { Router } from 'react-router-dom';
import App from './layouts';
import 'antd/dist/antd.less';
import './styles/index.less';
import './helpers/i18n';
import { QueryClientProvider } from 'react-query';
import queryClient from './queryClient';
import AppLocaleProvider from './components/app/AppLocaleProvider';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <React.StrictMode>
    <AppProvider>
      <Router history={history}>
        <QueryClientProvider client={queryClient}>
          <AppLocaleProvider>
            <App />
          </AppLocaleProvider>
        </QueryClientProvider>
      </Router>
    </AppProvider>
  </React.StrictMode>,
);
